import { RequestStatus } from '../../enums';
import { makeAsyncReducerHandlers } from '../../helpers';
import { InterviewsActionTypes, ProjectsActionTypes } from '../../actions/types';


const getInterviewsInfo = makeAsyncReducerHandlers(
  InterviewsActionTypes.getInterviewsInfo,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.interviews,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const sendInterviewInvite = makeAsyncReducerHandlers(
  InterviewsActionTypes.sendInterviewInvite,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [...state.items, action.payload.interview],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateInterview = makeAsyncReducerHandlers(
  InterviewsActionTypes.updateInterview,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { interview } = action.payload;

    return {
      items: state.items.map(i => (i._id === interview._id ? interview : i)),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProjectOverviewDataByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchProjectOverviewDataByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.interviews,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProjectOverviewDataByCustomerId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchProjectOverviewDataByCustomerId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.interviews,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const attachFileToInterview = makeAsyncReducerHandlers(
  InterviewsActionTypes.attachFileToInterview,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { interview } = action.payload;

    return {
      items: state.items.map(i => (i._id === interview._id ? interview : i)),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);
const deleteFileFromInterview = makeAsyncReducerHandlers(
  InterviewsActionTypes.deleteFileFromInterview,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { interview } = action.payload;

    return {
      items: state.items.map(i => (i._id === interview._id ? interview : i)),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const downloadFileOfInterview = makeAsyncReducerHandlers(
  InterviewsActionTypes.downloadFileOfInterview,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { interview } = action.payload;

    return {
      items: state.items.map(i => (i._id === interview._id ? interview : i)),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const toggleAudioFilesRequired = makeAsyncReducerHandlers(
  InterviewsActionTypes.toggleAudioFilesRequired,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { interview } = action.payload;

    return {
      items: state.items.map(i => (i._id === interview._id ? interview : i)),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getProjectAndBookData = makeAsyncReducerHandlers(
  ProjectsActionTypes.getProjectAndBookData,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.interviews,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchChaptersAndResourcesByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchChaptersAndResourcesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.interviews,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getBookSampleAndResourcesByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.getBookSampleAndResourcesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.interviews,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);
const transcribeFileOfInterview = makeAsyncReducerHandlers(
  InterviewsActionTypes.transcribeFileOfInterview,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { interview } = action.payload;

    return {
      items: state.items.map(i => (i._id === interview._id ? interview : i)),
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

export default {
  getInterviewsInfo,
  sendInterviewInvite,
  updateInterview,
  fetchProjectOverviewDataByProjectId,
  fetchProjectOverviewDataByCustomerId,
  attachFileToInterview,
  deleteFileFromInterview,
  downloadFileOfInterview,
  toggleAudioFilesRequired,
  getProjectAndBookData,
  fetchChaptersAndResourcesByProjectId,
  getBookSampleAndResourcesByProjectId,
  transcribeFileOfInterview,
};
